import { gql } from "config/graphql";

export const CLASSIFICATION_FIELDS = gql`
  fragment ClassificationFields on Classification {
    id
    name
    gender
  }
`;
